import {unified} from 'unified'

import remark_parse from 'remark-parse'
import remark_directive from 'remark-directive'
import remark_rehype from 'remark-rehype'
import remark_images from 'remark-unwrap-images'

import rehype_format from 'rehype-format'
import rehype_stringify from 'rehype-stringify'

import {visit} from 'unist-util-visit'
import {h} from 'hastscript'


/**
 * Configures the settings for remark and then converts data.
 * @param {HTMLElement} element 
 */
export async function convert(element) {
  const data = await unified()
    .use(remark_parse)
    .use(remark_images)
    .use(remark_directive)
    .use(remark_add_tags)
    .use(remark_rehype)
    .use(rehype_format)
    .use(rehype_stringify)
    .process(element.dataset.markdown)

  element.removeAttribute('data-markdown');
  element.innerHTML = data

  return data
}

function remark_add_tags() {
  return (tree) => {
    visit(tree, (node) => {
      if (
        node.type === 'textDirective' ||
        node.type === 'leafDirective' ||
        node.type === 'containerDirective'
      ) {
        const data = node.data || (node.data = {})
        const hast = h(node.name, node.attributes)

        data.hName = hast.tagName
        data.hProperties = hast.properties
      }
    })
  }
}